import * as util from "util";
declare type IError = Error;

export module CustomErrors {

  abstract class CustomError {
    private stack;

    constructor(public name: string, public message: string) {
      if (Error.captureStackTrace) {
        Error.captureStackTrace(this, this.constructor);
      }
      else {
        this.stack = (new Error()).stack;
      }
    }
  }

  export class ApiError extends CustomError implements IFetchApiFailure {
    text: string;
    json: any;
    validations: IValidationError[];
    response: { status: number, isPrimary?: boolean };
    
    constructor(message: string, response: IFetchApiResponse<any>) {
      super("ApiError", response?.json?.message ?? response?.message ?? message);

      if (response) {
        this.text = response.text;
        this.json = response.json;
        this.response = response.response;
        if (response.response.status === 422) {
          const resp: IValidationErrorResponse = response.json;
          this.validations = resp ? resp.errors : undefined;
        }
      }
    }
  }

  export class CannotRenderOnServerError extends CustomError {
    constructor(message: string) {
      super("CannotRenderOnServerError", message);

      Error.captureStackTrace(this, this.constructor);
    }
  }
}

util.inherits(CustomErrors.ApiError, Error);
util.inherits(CustomErrors.CannotRenderOnServerError, Error);
